export function concat(sep: string, ...args: (string | null | undefined)[]) {
  return args.filter(Boolean).join(sep);
}
